module.exports = __webpack_public_path__ + "static/media/MHRP21N0002.048700f9.svg";